export function nestedCalc(calc: string) {
  const justMath = calc.replace(/\bcalc\(/g, '(')
  return `calc(${justMath})`
}
